import { useSelector } from 'react-redux'
import userSelectors from '../../store/selectors/user.selectors'

const useAuthorization = (roles = [], types = []) => {
    const user = useSelector(userSelectors.user) || {}
    const loading = useSelector(userSelectors.isWaitingForGetCurrentUser)

    let userRoles = user.roles || []
    // userRoles = isSystemAdmin(userRoles, user.type) ? Object.values(UserRoles) : userRoles // SN-4825 asked to remove this

    const isLoggedIn = Boolean(user && Object.keys(user).length)
    const hasRequiredRole = roles.length === 0 || (user && roles.some(role => userRoles.includes(role)))
    const hasRequiredType = types.length === 0 || (user && types.includes(user.type))

    const isAuthorized = isLoggedIn && hasRequiredRole && hasRequiredType

    return { isAuthorized, isLoggedIn, loading }
}

export default useAuthorization
